import { classNames } from "shared/lib/classNames/classNames";
import cls from "./Title.module.scss";

export enum TitleTheme {
    NEUTRAL = "neutral",
    PRIMARY = "primary",
}

export interface TitleProps {
    sentences: Array<string>;
    colors?: Array<TitleTheme>;
    //theme?: TitleTheme;
    backgroundColor?: boolean;
    alignRight?: boolean;
    className?: string;
    padded?: boolean;
}

const Title = ({ className, sentences, colors, backgroundColor, alignRight, padded }: TitleProps) => {
    return (
        <div className={classNames(cls.Title, {
            [cls.right]: alignRight,
        }, [className])}>
                {sentences.map((sentence, index) => {
                    return (
                            <div className={classNames(cls.Title__sentence, {
                                [cls.Title__sentence_bg]: backgroundColor,
                                [cls.Title__sentence_padded]: padded
                            }, [colors && cls[colors[index]]])}>{sentence}</div>
                    )
                })}
        </div>
    )
};

export default Title;

